(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-agreement"] && !Shopify.designMode) return;
  try {
    (() => {
    const showError = (input) => {
      input.setAttribute('aria-invalid', 'true');
      const error = document.getElementById('CartAgreementError');
      if (error) error.hidden = false;
    };
    document.addEventListener('invalid', (event) => {
      if (event.target.matches('[data-cart-agreement]')) showError(event.target);
    }, true);
    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!input.matches('[data-cart-agreement]')) return;
      input.removeAttribute('aria-invalid');
      const error = document.getElementById('CartAgreementError');
      if (error) error.hidden = true;
    });
    document.addEventListener('submit', (event) => {
      if (event.target.id !== 'CartForm' || event.submitter?.name === 'update') return;
      const input = event.target.querySelector('[data-cart-agreement]');
      if (input && !input.checked) {
        event.preventDefault();
        showError(input);
        input.focus();
      }
    });
    window.addEventListener('pageshow', () => {
      const input = document.querySelector('[data-cart-agreement]');
      if (input) input.checked = false;
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cinema-script"] && !Shopify.designMode) return;
  try {
    (() => {
  const active = new WeakMap();
  const initialize = (scope) => {
    scope.querySelectorAll('[data-cinema]').forEach((root) => {
      if (active.has(root)) return;
      const aborter = new AbortController();
      active.set(root, aborter);
      const get = (name) => root.querySelector('[data-cinema-' + name + ']');
      let data, labels;
      try {
        data = JSON.parse(get('data').textContent);
        labels = JSON.parse(get('labels').textContent);
      } catch {
        get('error').textContent = root.dataset.error;
        get('error').hidden = false;
        return;
      }
      let products = data.products;
      let nextPage = data.next;
      let matches = [];
      let index = 0;
      let loading = false;
      const storageKey = 'cc-cinema:' + location.pathname;
      let saved = null;
      try { saved = JSON.parse(sessionStorage.getItem(storageKey)); } catch {}
      const filters = Object.fromEntries([...root.querySelectorAll('[data-filter]')].map(el => [el.dataset.filter, el]));
      const collator = new Intl.Collator(document.documentElement.lang || 'de', { numeric: true, sensitivity: 'base' });
      const substitute = (text, values) => Object.entries(values).reduce((str,[key,value]) => str.replaceAll('%' + key + '%', String(value)), text);
      const fillOptions = (select, values) => {
        const current = select.value;
        const first = select.options[0].cloneNode(true);
        select.replaceChildren(first);
        [...new Set(values.filter(Boolean))].sort(collator.compare).forEach(value => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          select.append(option);
        });
        select.value = [...select.options].some(option => option.value === current) ? current : '';
      };
      const populate = () => {
        fillOptions(filters.size, products.flatMap(product => product.sizes));
        fillOptions(filters.type, products.map(product => product.type));
      };
      const persist = () => {
        try { sessionStorage.setItem(storageKey, JSON.stringify({
          filters: Object.fromEntries(Object.entries(filters).map(([key, el]) => [key, el.type === 'checkbox' ? el.checked : el.value])),
          productId: matches[index]?.id
        })); } catch {}
      };
      const setText = (name, value) => { get(name).textContent = value; };
      const setLink = (name, href) => {
        const url = new URL(href, location.origin);
        if (url.origin === location.origin) get(name).href = url.href;
      };
      const render = (announce = true) => {
        const item = matches[index];
        const count = matches.length === 1 ? labels.countOne : substitute(labels.count, { count: matches.length });
        setText('count', count + (loading ? ' · ' + labels.loading : ''));
        const activeFilters = Object.values(filters).filter(el => el.type === 'checkbox' ? el.checked : el.value).length;
        setText('filter-summary', activeFilters ? substitute(labels.filterActive, {count: activeFilters}) : labels.filterToggle);
        get('stage').hidden = !item;
        get('empty').hidden = Boolean(item);
        get('controls').hidden = !item;
        persist();
        if (!item) {
          if (announce) setText('announcement', labels.empty);
          return;
        }
        setText('title', item.title);
        setText('type', item.type || labels.typeMissing);
        setText('kind', item.type || labels.typeMissing);
        setText('price', item.priceLabel);
        const discounted = item.compare > item.price;
        get('compare').hidden = !discounted;
        get('sale').hidden = !discounted;
        setText('compare', item.compareLabel);
        setText('condition', labels[item.condition] || '');
        setText('gender', item.women && item.men ? labels.women + ' / ' + labels.men : item.women ? labels.women : item.men ? labels.men : labels.unisex);
        const sizeContainer = get('sizes');
        sizeContainer.replaceChildren();
        (item.sizes.length ? item.sizes : [labels.sizeMissing]).forEach(size => {
          const badge = document.createElement('span');
          badge.textContent = size;
          sizeContainer.append(badge);
        });
        setLink('product-link', item.url);
        setLink('image-link', item.url);
        const image = get('image');
        image.hidden = !item.image;
        get('no-image').hidden = Boolean(item.image);
        if (item.image) {
          image.src = item.image;
          image.alt = item.title;
          image.decoding = 'async';
        } else image.removeAttribute('src');
        setText('take', 'TAKE ' + String(index + 1).padStart(3, '0'));
        const position = substitute(labels.position, { current: index + 1, total: matches.length });
        setText('position', position);
        get('progress').style.width = (index + 1) / matches.length * 100 + '%';
        get('prev').disabled = matches.length < 2;
        get('next').disabled = matches.length < 2;
        get('shuffle').disabled = matches.length < 2;
        if (announce) setText('announcement', position + '. ' + item.title + '. ' + item.priceLabel);
        const upcoming = matches[(index + 1) % matches.length];
        if (upcoming?.image && upcoming.image !== item.image) {
          const preload = new Image();
          preload.src = upcoming.image;
        }
      };
      const apply = (announce = true, preserve = false) => {
        const currentId = preserve ? matches[index]?.id : null;
        matches = products.filter(item => {
          const gender = filters.gender.value;
          if (gender === 'women' && !item.women) return false;
          if (gender === 'men' && !item.men) return false;
          if (gender === 'unisex' && !((item.women && item.men) || (!item.women && !item.men))) return false;
          if (filters.size.value && !item.sizes.includes(filters.size.value)) return false;
          if (filters.type.value && item.type !== filters.type.value) return false;
          if (filters.price.value && item.price > Number(filters.price.value)) return false;
          if (filters.sale.checked && item.compare <= item.price) return false;
          return true;
        });
        index = Math.max(0, matches.findIndex(item => item.id === currentId));
        render(announce);
      };
      const step = (offset) => {
        if (!matches.length) return;
        index = (index + offset + matches.length) % matches.length;
        render();
      };
      get('image').addEventListener('error', () => {
        get('image').hidden = true;
        get('no-image').hidden = false;
      }, {signal:aborter.signal});
      root.addEventListener('change', event => {
        if (event.target.matches('[data-filter]')) apply();
      }, {signal:aborter.signal});
      root.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !root.contains(button)) return;
        if (button.hasAttribute('data-cinema-filter-toggle')) {
          get('filters').hidden = !get('filters').hidden;
          button.setAttribute('aria-expanded', String(!get('filters').hidden));
        }
        if (button.hasAttribute('data-cinema-prev')) step(-1);
        if (button.hasAttribute('data-cinema-next')) step(1);
        if (button.hasAttribute('data-cinema-shuffle') && matches.length > 1) step(1 + Math.floor(Math.random() * (matches.length - 1)));
        if (button.hasAttribute('data-cinema-reset')) {
          Object.values(filters).forEach(filter => { filter.type === 'checkbox' ? filter.checked = false : filter.value = ''; });
          apply();
        }
        if (button.hasAttribute('data-cinema-retry')) loadRemaining();
      }, {signal:aborter.signal});
      root.addEventListener('keydown', event => {
        if (event.target.closest('input,select,textarea,[contenteditable="true"]')) return;
        if (event.altKey || event.metaKey || event.ctrlKey) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          step(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, {signal:aborter.signal});
      const loadRemaining = async () => {
        if (loading || !nextPage) return;
        loading = true;
        get('error').hidden = true;
        get('retry').hidden = true;
        render(false);
        const seen = new Set();
        try {
          while (nextPage && root.isConnected && !aborter.signal.aborted) {
            const url = new URL(nextPage, location.origin);
            if (url.origin !== location.origin || seen.has(url.href)) throw new Error('Invalid page');
            seen.add(url.href);
            url.searchParams.set('view', 'cinema');
            url.searchParams.set('section_id', root.dataset.sectionId);
            const response = await fetch(url, {signal:aborter.signal});
            if (!response.ok) throw new Error('Request failed');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const chunk = JSON.parse(html.querySelector('[data-cinema-data]').textContent);
            const ids = new Set(products.map(product => product.id));
            products.push(...chunk.products.filter(product => !ids.has(product.id)));
            nextPage = chunk.next;
            populate();
            apply(false, true);
          }
        } catch (error) {
          if (error.name !== 'AbortError') {
            setText('error', labels.error);
            get('error').hidden = false;
            get('retry').hidden = false;
          }
        } finally {
          loading = false;
          if (root.isConnected) render(false);
        }
      };
      populate();
      if (saved?.filters) {
        Object.entries(filters).forEach(([key, el]) => {
          if (el.type === 'checkbox') el.checked = saved.filters[key] === true;
          else if ([...el.options].some(option => option.value === saved.filters[key])) el.value = saved.filters[key];
        });
      }
      const compact = window.matchMedia?.('(max-width: 749px)');
      get('filters').hidden = Boolean(compact?.matches);
      get('filter-toggle').hidden = false;
      get('filter-toggle').setAttribute('aria-expanded', String(!get('filters').hidden));
      compact?.addEventListener('change', event => {
        if (!event.matches) {
          get('filters').hidden = false;
          get('filter-toggle').setAttribute('aria-expanded', 'true');
        }
      }, {signal: aborter.signal});
      get('keyboard').hidden = false;
      apply(false);
      if (saved?.productId) {
        const previous = matches.findIndex(item => item.id === saved.productId);
        if (previous >= 0) { index = previous; render(false); }
      }
      loadRemaining();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-cinema]').forEach(root => active.get(root)?.abort());
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["consent-banner-styles"] && !Shopify.designMode) return;
  try {
    (() => {
    let openBanner = null;
    let returnFocus = null;
    let pending = false;
    const visible = (element) => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
    const focusable = (banner) => [...banner.querySelectorAll('a[href], button, input, [tabindex="0"]')].filter(element => !element.disabled && visible(element));
    const enhance = () => {
      pending = false;
      const banner = document.getElementById('banner-wrapper');
      if (!banner) return;
      if (banner.getAttribute('role') !== 'dialog') {
        banner.setAttribute('role', 'dialog');
        banner.setAttribute('aria-modal', 'true');
        banner.setAttribute('aria-label', banner.querySelector('.banner-header__title')?.textContent.trim() || 'Cookies');
      }
      banner.querySelectorAll('.banner-main_buttons p').forEach(button => {
        if (button.getAttribute('role') === 'button') return;
        button.setAttribute('role', 'button');
        button.tabIndex = 0;
        button.addEventListener('keydown', event => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          (button.querySelector('[data-cookie-accept-all], [data-cookie-save]') || button).click();
        });
      });
      const isOpen = visible(banner) && getComputedStyle(banner).display !== 'none';
      if (isOpen && openBanner !== banner) {
        returnFocus = document.activeElement;
        openBanner = banner;
        focusable(banner)[0]?.focus();
      } else if (!isOpen && openBanner === banner) {
        openBanner = null;
        if (returnFocus?.isConnected) returnFocus.focus();
      }
    };
    document.addEventListener('keydown', event => {
      if (event.key !== 'Tab' || !openBanner) return;
      const elements = focusable(openBanner);
      const first = elements[0];
      const last = elements[elements.length - 1];
      if (!first) return;
      if (event.shiftKey && (document.activeElement === first || !openBanner.contains(document.activeElement))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !openBanner.contains(document.activeElement))) {
        event.preventDefault();
        first.focus();
      }
    });
    new MutationObserver(() => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(enhance);
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    enhance();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["premiere-script"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialized = new WeakSet();
  const initialize = scope => scope.querySelectorAll('[data-premiere]').forEach(root => {
    if (initialized.has(root)) return;
    initialized.add(root);
    const cards = [...root.querySelectorAll('[data-premiere-card]')];
    if (cards.length < 2) return;
    const position = root.querySelector('[data-premiere-position]');
    const status = root.querySelector('[data-premiere-status]');
    let index = 0;
    const show = announce => {
      cards.forEach((card, i) => { card.hidden = i !== index; });
      position.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(cards.length).padStart(2, '0');
      const nextImage = cards[(index + 1) % cards.length].querySelector('img');
      if (nextImage) nextImage.loading = 'eager';
      if (announce) status.textContent = position.textContent + '. ' + cards[index].dataset.announcement;
    };
    root.querySelector('[data-premiere-controls]').hidden = false;
    root.addEventListener('click', event => {
      const next = event.target.closest('[data-premiere-next]');
      const previous = event.target.closest('[data-premiere-prev]');
      if (!next && !previous) return;
      index = (index + (next ? 1 : -1) + cards.length) % cards.length;
      show(true);
    });
    show(false);
  });
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["theme-script"] && !Shopify.designMode) return;
  try {
    (() => {
    const requests = new WeakMap();
    document.addEventListener('change', async (event) => {
      if (!(event.target instanceof HTMLInputElement) || !event.target.matches('[data-option-value-id]'))
        return;
      const root = event.target.closest('[data-product-root]');
      if (!root) return;
      const pending = requests.get(root);
      pending?.controller.abort();
      const controller = new AbortController();
      const selectedId = event.target.dataset.optionValueId;
      const status = root.querySelector('[data-product-status]');
      const addButton = root.querySelector('[data-add-button]');
      const variantInput = root.querySelector('[data-variant-input]');
      const wasDisabled = pending?.buttonDisabled ?? addButton?.disabled;
      const inputWasDisabled = pending?.variantDisabled ?? variantInput?.disabled;
      requests.set(root, { controller, buttonDisabled: wasDisabled, variantDisabled: inputWasDisabled });
      if (addButton) addButton.disabled = true;
      if (variantInput) variantInput.disabled = true;
      root.setAttribute('aria-busy', 'true');
      if (status) status.textContent = '';
      const url = new URL(root.dataset.productUrl, window.location.origin);
      const optionValues = Array.from(
        root.querySelectorAll('[data-option-value-id]:checked'),
        (input) => input.dataset.optionValueId,
      ).join(',');
      url.searchParams.set('section_id', root.dataset.sectionId);
      url.searchParams.set('option_values', optionValues);
      try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Variant request failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const updated = html.querySelector('[data-product-root]');
        if (
          !updated ||
          updated.dataset.sectionId !== root.dataset.sectionId ||
          !updated.querySelector('[data-add-button]')
        )
          throw new Error('Invalid variant response');
        if (controller.signal.aborted || !root.isConnected) return;
        root.replaceWith(updated);
        const selectedInput = Array.from(updated.querySelectorAll('[data-option-value-id]')).find(
          (input) => input.dataset.optionValueId === selectedId,
        );
        selectedInput?.focus({ preventScroll: true });
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.delete('option_values');
        if (updated.dataset.variantId) {
          currentUrl.searchParams.set('variant', updated.dataset.variantId);
        } else {
          currentUrl.searchParams.delete('variant');
          currentUrl.searchParams.set('option_values', optionValues);
        }
        window.history.replaceState({}, '', currentUrl);
        window.Shopify?.PaymentButton?.init();
      } catch (error) {
        if (error.name === 'AbortError' || controller.signal.aborted) return;
        root.querySelectorAll('[data-option-value-id]').forEach((input) => {
          input.checked = input.defaultChecked;
        });
        if (addButton) addButton.disabled = wasDisabled;
        if (variantInput) variantInput.disabled = inputWasDisabled;
        if (status) status.textContent = status.dataset.error;
      } finally {
        if (requests.get(root)?.controller === controller) {
          root.removeAttribute('aria-busy');
          requests.delete(root);
        }
      }
    });
    document.addEventListener('click', async (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      document.querySelectorAll('[data-mobile-menu][open],.nav-dropdown[open]').forEach((details) => {
        if (!details.contains(target)) details.open = false;
      });
      const share = target.closest('[data-share]');
      if (share) {
        const status = share.parentElement.querySelector('[data-share-status]');
        try {
          await navigator.clipboard.writeText(window.location.href);
          if (status) status.textContent = share.dataset.copied;
        } catch {
          if (status) status.textContent = share.dataset.error;
        }
      }
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-mobile-menu][open],.nav-dropdown[open]').forEach((details) => {
        details.open = false;
        details.querySelector('summary')?.focus();
      });
    });
    document.addEventListener(
      'toggle',
      (event) => {
        const opened = event.target;
        if (!(opened instanceof HTMLDetailsElement) || !opened.open || !opened.matches('.nav-dropdown'))
          return;
        document.querySelectorAll('.nav-dropdown[open]').forEach((details) => {
          if (details !== opened) details.open = false;
        });
      },
      true,
    );
    document.addEventListener(
      'play',
      (event) => {
        if (!(event.target instanceof HTMLVideoElement)) return;
        document.querySelectorAll('.social-card video').forEach((video) => {
          if (video !== event.target) video.pause();
        });
      },
      true,
    );
    const loadRecommendations = async (element) => {
      if (element.dataset.loaded || !element.dataset.url) return;
      element.dataset.loaded = 'true';
      try {
        const url = new URL(element.dataset.url, window.location.origin);
        if (url.origin !== window.location.origin) return;
        const response = await fetch(url);
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = html.querySelector('[data-recommendations]');
        if (content && element.isConnected) element.innerHTML = content.innerHTML;
      } catch {}
    };
    const observer =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  observer.unobserve(entry.target);
                  loadRecommendations(entry.target);
                }
              });
            },
            { rootMargin: '400px' },
          )
        : null;
    const initialize = (scope) => {
      scope.querySelectorAll('[data-recommendations]').forEach((element) => {
        if (observer) observer.observe(element);
        else loadRecommendations(element);
      });
    };
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target
        .querySelectorAll('[data-product-root]')
        .forEach((root) => requests.get(root)?.controller.abort());
      event.target
        .querySelectorAll('[data-recommendations]')
        .forEach((element) => observer?.unobserve(element));
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
